import { Link } from "react-router-dom";
import { Button } from "../../components/ui/Button";

export default function NotFound() {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4 bg-surface px-4 text-center">
      <p className="text-6xl font-black text-primary/20">404</p>
      <h1 className="text-xl font-bold text-ink">Pagina non trovata</h1>
      <p className="max-w-sm text-sm text-ink/50">La pagina che cerchi non esiste o è stata spostata.</p>
      <Link to="/">
        <Button variant="secondary">Torna alla Dashboard</Button>
      </Link>
    </div>
  );
}
